'use client';

import { __makeTemplateObject } from '../_virtual/_tslib.js';
import styled from 'styled-components';

var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n"], ["\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n"])));
var MoreButton = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    justify-content: center;\n\n"], ["\n    display: flex;\n    justify-content: center;\n\n"])));
var templateObject_1, templateObject_2;

export { Container, MoreButton };
//# sourceMappingURL=JobCardList.css.js.map
